<template>
  <div>
    <sms-verification-input v-if="inputTab" :toggle-tab="toggleTab" :set-phone="setPhone"></sms-verification-input>
    <sms-verification-code v-if="codeTab" :toggle-tab="toggleTab" :phone="phone"></sms-verification-code>
  </div>
</template>

<script>
import SmsVerificationInput from "@/views/pages/auth/sms-verification/components/SmsVerificationInput";
import SmsVerificationCode from "@/views/pages/auth/sms-verification/components/SmsVerificationCode";
export default {
  name: "SmsVerification",
  components: {
    SmsVerificationInput,
    SmsVerificationCode
  },
  data() {
    return {
      tabIndex: 1,
      phone: ""
    }
  },
  computed: {
    inputTab() {
      return this.tabIndex === 1;
    },
    codeTab() {
      return this.tabIndex === 2;
    }
  },
  methods: {
    toggleTab(index) {
      this.tabIndex = index;
    },
    setPhone(phone) {
      this.phone = phone;
    }
  }
}
</script>

<style scoped>

</style>
